var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "css-1j8o68f",
    viewBox: "49 0 102 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs8891"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient8898"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop8899",
    stopColor: "#8f5e25",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop8900",
    stopColor: "#fbf4a1",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop8901",
    stopColor: "#8f5e25",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient8902"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop8903",
    stopColor: "#8f5e25",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop8904",
    stopColor: "#fbf4a1",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop8905",
    stopColor: "#8f5e25",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG8892",
    featurekey: "symbolGroupContainer",
    transform: "matrix(1,0,0,1,49,0)",
    fill: "url(#SvgjsLinearGradient8898)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 115
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG8893",
    featurekey: "Wg4LIr-0",
    transform: "matrix(6.548535959361426,0,0,6.548535959361426,64.41602607748112,-30.970719187228525)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.18 14.559999999999999 l-2.1 0 l0 5.44 l2.1 0 l0 -5.44 z M8.08 14.559999999999999 l0 -2.08 l-5.3 0 l-2.08 0 l0 -5.46 l2.08 0 l0 5.46 l0 2.08 l5.3 0 z M8.08 12.48 l2.1 0 l0 -5.46 l-2.1 0 l0 5.46 z M2.78 14.559999999999999 l-2.08 0 l0 5.44 l2.08 0 l0 -5.44 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.57de927677154ea8a87c4a4828d2524d.svg";
export { ForwardRef as ReactComponent };